import Validation from './validation'
import ValidationError from './validation-error'

class BusinessEmail extends Validation {
	constructor(drForm) {
		super();
		this.target = '.calc-email';
		this.selector = 'validate-business-email';
		this.rule = 'isBusinessEmail';
		this.checker = 'validateBusinessEmail';
		this.init(drForm);
	}

	validate(email) {
		if (!this.isValidEmail(email)) {
			throw new ValidationError('Please provide a correct email address');
		}
		let list = this.getWhitelist('dr_free_emails');
		if (this.isDomainInList(email, list)) {
			throw new ValidationError('Please provide a correct business email address');
		}
		return true;
	}

	/**
	 * Get the list of emails for this field's validation and push it to 'dr'
	 */
	getWhitelist(listName) {
		if (dr.hasOwnProperty(listName)) {
			return dr[listName];
		} else {
			let responce = jQuery.post({
				url: dr.js_data.rest_api.forms.get_free_email_domains,
				async: false,
				data: {
					action: listName,
				}
			});
			if (!responce.responseJSON.data.length && !Object.keys(responce.responseJSON.data).length) {
				throw new ValidationError();
			}
			dr[listName] = responce.responseJSON.data;
			return responce.responseJSON.data;
		}
	}

	isDomainInList(input, domainStack) {
		let atIndex = input.lastIndexOf('@');
		if (atIndex > 0) {
			let domain = input.substring(atIndex + 1).trim();
			if (domain !== '') {
				let itemIndex = domainStack.indexOf(domain);
				return (itemIndex >= 0);
			}
		}
		return false;
	}

	isValidEmail(input) {
		let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (!re.test(input)) {
			throw new ValidationError('Please make sure your email address is correct.');
		}
		return true;
	}
}

export default BusinessEmail;
